// extracted by mini-css-extract-plugin
export default {"loading":"index_loading_W6qNF"};